import React from 'react'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Pareto from 'highcharts/modules/pareto';
import SolidGauge from 'highcharts/modules/solid-gauge';
import Highcharts from "@material-ui/core/es/styles/withStyles";
import Card from "../common/Card";
import {COLOR_chart_barra_serie_0} from "../common/CustomTheme/grayyellow/colors";


HighchartsMore(ReactHighcharts.Highcharts);
Pareto(ReactHighcharts.Highcharts);
SolidGauge(ReactHighcharts.Highcharts);


export default function OSESeriesDHChart(prop) {
    const { series, title, serieTitle, roitreadColunas } = prop;
    let categories = [];
    let bTotal = [];

    console.log("serieschart", series)

    if (series) {
        let ultd = "";
        series.map(i => {
            if (i.Data !== ultd) {
                categories.push(i.Data.substring(0, 10) + ' ' + i.Hora);
                ultd = i.Data;
            } else {
                categories.push(i.Hora);
            }
            if (!roitreadColunas) {
                bTotal.push(i.QtdeCiclos);
            } else {
                bTotal.push([i.Coluna1, i.Coluna2, i.Coluna3])
            }
        })
    }

    const config = {
        chart: {
            type: 'series',
            zoomType: 'x'
        },
        legend: {
            enabled: true
        },
        title: {
            text: title
        },
        xAxis: {
            categories: categories,
            title: {
                text: ''
            }
        },
        plotOptions: {
            pareto: {
                marker: {
                    enabled: false
                }
            },
            column: {
                stacking: 'normal',
                dataLabels: {
                    enabled: true,
                    color: 'blue',
                    format: '{point.y:.0f}',
                    rotation: 270
                }
            }
        },
        yAxis: [
            {
                    title: { text: '' }
            }

        ],
        series: [
            {
                type: 'column',
                name: serieTitle,
                data: bTotal,
                color: COLOR_chart_barra_serie_0
            }
        ]

    };

    return (
        <Card>
            <ReactHighcharts config = {config}>
            </ReactHighcharts>
        </Card>
    )
}
